// extracted by mini-css-extract-plugin
export var createdDate = "_mj-1";
export var divider = "_mj-2";
export var headerDivider = "_mj-3";
export var messagesCard = "_mj-0";
export var messagesContainer = "_mj-7";
export var messagesContainerWrapper = "_mj-4";
export var pointerCapturingButtonBoxes = "_mj-a";
export var showLeftPanelButton = "_mj-9";
export var showMoreButton = "_mj-c";
export var showMoreButtonContainer = "_mj-b";
export var summaryTitle = "_mj-6";
export var systemMessageCardWrapper = "_mj-d";
export var topButtons = "_mj-8";
export var withPadding = "_mj-5";